module.exports = __webpack_public_path__ + "img/harry-mohr-seite.3831da92.png";